import { render, staticRenderFns } from "./teenagerBody.vue?vue&type=template&id=607a6272&scoped=true&"
import script from "./teenagerBody.vue?vue&type=script&lang=js&"
export * from "./teenagerBody.vue?vue&type=script&lang=js&"
import style0 from "./teenagerBody.vue?vue&type=style&index=0&id=607a6272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a6272",
  null
  
)

export default component.exports